module.exports = __webpack_public_path__ + "img/liveBg.abfb91c5.png";